import { Form } from "antd";
import styled, { css } from "styled-components";

import { Palette } from "../../../../core/styles/theme";

const Styles = css`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    box-shadow:
        ${Palette.ShadowEndColor} 0 13px 27px -5px,
        ${Palette.ShadowStartColor} 0 8px 16px -8px;
    padding: 40px 80px;

    & .logo-wrapper {
        display: flex;
        justify-content: center;
    }

    & .title-wrapper {
        display: flex;
        justify-content: center;
        padding: 15px 0 60px;
    }

    & .footer-wrapper {
        display: flex;
        justify-content: center;
        padding-top: 80px;
    }

    & .confirmation-button-wrapper {
        width: 100%;
        margin-top: 15px;
    }

    & .aevi-button {
        float: right;
    }
`;

export const StyledDiv = styled.div`
    ${Styles};
`;

export const LogoWrapper = styled.div.attrs(() => ({ className: "logo-wrapper" }))``;

export const TitleWrapper = styled.div.attrs(() => ({ className: "title-wrapper" }))``;

export const FooterWrapper = styled.div.attrs(() => ({ className: "footer-wrapper" }))``;

export const ConfirmationButtonWrapper = styled(Form.Item).attrs(() => ({ className: "confirmation-button-wrapper" }))``;
